import { BomDto } from "src/dtos/bom/BomDto";
import { XycoordinateDto } from "src/dtos/xyCoordinate/xyCoordinateDto";
import { formatDate } from "src/utils/string/stringUtil";

export interface MST3040_R01Dto {
	bomHeaderDto: MST3040_R01HeaderDto;
	xyCoordinateDetailDtoList: MST3040_R01DetailDto[];
}

export interface MST3040_R01HeaderDto extends BomDto {

	itemNm: string;
	itemUnit: string;

	inserted: boolean,
	isModified: boolean,

    
}

/**
 * 생산 실적 관리의 단일 기본 데이터 (신규 행 추가시 사용)
 */
export const defaultMST3040_R01HeaderDto: MST3040_R01HeaderDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,
	
	prntItemcd: '',
	prntItemnm: '',
	childItemcd: '',
	childItemnm: '',
	itemSpec: '',
	bomSeq: 0,
	bomUseyn: 'Y',
	bomUpdateNo: '1', // 기본값을 '1'로 설정
	prntItemQty: 1,
	prntItemUnit: 'EA',
	childItemUsage: 0,
	childItemUnit: 'EA',
	fixLossqty: 0,
	materialIntype: 'PURCHASE', // 기본값: 구매
	lossPercent: 0,
	remark: '',

	itemNm: '',
	itemUnit: '',

	inserted: false,
	isModified: false


};

export interface MST3040_R01DetailDto extends XycoordinateDto {

	childItemnm: string;
	itemSpec: string;
	locationCd: string;
	locationNm: string;

	inserted: boolean,
	isModified: boolean,

}

export const defaultMST3040_R01DetailDto: MST3040_R01DetailDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	prntItemcd: '',
	coordinateCd: '',
	coordinateSeq: 0,
	coordinateNm: '',
	coordinateUsage: 0,
	xcoordinate: 0,
	ycoordinate: 0,
	orient: 0,
	topBottom: '',
	childItemcd: '',
	applyBeginDt: formatDate(new Date()),
	applyEndDt: formatDate(new Date()),
	afeederCd: '',
	bfeederCd: '',
	cfeederCd: '',
	remark: '',

	childItemnm: '',
	itemSpec: '',
	locationCd: '',
	locationNm: '',

	inserted: false,
	isModified: false,
}	


export interface MST3040_R01UsageDto extends BomDto {

	itemUnit: string;

	coordinateUsage: number;

	usageDifference: number;	// 소요량 차이

	inserted: boolean,
	isModified: boolean,

}

export const defaultMST3040_R01UsageDto: MST3040_R01UsageDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,
	
	prntItemcd: '',
	prntItemnm: '',
	childItemcd: '',
	childItemnm: '',
	itemSpec: '',
	bomSeq: 0,
	bomUseyn: 'Y',
	bomUpdateNo: '1', // 기본값을 '1'로 설정
	prntItemQty: 1,
	prntItemUnit: 'EA',
	childItemUsage: 0,
	childItemUnit: 'EA',
	fixLossqty: 0,
	materialIntype: 'PURCHASE', // 기본값: 구매
	lossPercent: 0,
	remark: '',

	itemUnit: '',

	coordinateUsage: 0,
	usageDifference: 0,
	
	inserted: false,
	isModified: false
}	